import Box from '@mui/material/Box'
import styled from '@emotion/styled'
import Link from 'next/link'
import TitleWithRemark from 'components/common/TitleWithRemark'
import AppDownload from './AppDownload'
import HelfSplitGrid from './HelfSplitGrid'

const StyleHelfSplitGrid = styled(HelfSplitGrid)`
  ${({ theme }) => `
    grid-template-columns: 1fr;
    grid-row-gap: ${theme.spacing(4)};

    ${theme.breakpoints.up('lg')} {
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: 0;
    }
  `}
`

const SocialMediaBlock = ({ title, socialLinks }) => {
  return (
    <>
      <Box display="flex" flexDirection="column">
        <TitleWithRemark variant="labelLarge">{title}</TitleWithRemark>
      </Box>

      <StyleHelfSplitGrid py={{ xs: 4, lg: 5 }}>
        <Box display="flex" gap={{ xs: 3, lg: 4 }}>
          {socialLinks.map((social, index) => (
            <Link
              key={index}
              href={social.href || ''}
              target="_blank"
              rel="noopener noreferrer"
              style={{ cursor: 'pointer' }}
            >
              {social.icon}
            </Link>
          ))}
        </Box>
        <AppDownload />
      </StyleHelfSplitGrid>
    </>
  )
}

export default SocialMediaBlock
